/* globals Class, Event, $H, lp, jui */
var jQuery = require('jquery');

var rxUi = window.rxUi;

lp.editor.SectionTransformBox = Class.create( jui.Component, jui.EventSource, lp.editor.dnd.transformSectionDnDSource, {

  options: function($super,options){
    return $super($H({attributes:{className:'section-transform-box'}}).merge(options));
  },

  initialize: function( $super, editor, options ){
    this.editor = editor;
    this.elm = null;
    this.tracking = false;
    this.offset = [];
    this.boxOffset = [];
    this.handleW = 18;
    this.handleH = 17;
    this.handleNames = ['bmh'];
    this.dragThreshold = 3;
    this.startIndex = null;
    this.startPoint = null;

    this.undoRegistered = false;

    this.mouseMoveListener = this.mousemove.bindAsEventListener( this );
    this.mouseUpListener   = this.mouseup.bindAsEventListener( this );

    $super( options );

    var self = this;

    this.elmModelListener = this.elementModelChanged.bind(this);

    this.elementMoveListener = this.elementMoved.bindAsEventListener( this );

    this.elementVisibilityListener = function(e) {
      self[e.source.view.visible() ? 'show' : 'hide']();
    };

    this.adjustmentListener = function() {
      if (self.elm !== null && self.elm.type !== 'lp-pom-root') {
        self.positionBoundingBox();
      }
    };

    this.editor.addListener('layoutChanged', this.adjustmentListener);
    this.editor.addListener('elementActivated', this);
    this.editor.addListener('elementDeactivated', this);
    this.editor.addListener('activeRootChanged', this);
  },

  activeRootChanged: function(e) {
    var previous = e.data.previous;
    var root = e.data.current;
    if (previous !== null) {
      previous.removeListener('blockInserted', this.adjustmentListener);
      previous.removeListener('blockRemoved', this.adjustmentListener);
    }

    root.addListener('blockInserted', this.adjustmentListener);
    root.addListener('blockRemoved', this.adjustmentListener);
  },

  installUI: function( $super, options ) {
    $super( options );
    this._installBoundingBox();
    this._installHandles();
  },

  _installBoundingBox: function() {
    this.tbndry = this.insert( new Element('div', {className:'transform-boundary-top    transform-boundary top   '}));
    this.rbndry = this.insert( new Element('div', {className:'transform-boundary-right  transform-boundary right '}));
    this.bbndry = this.insert( new Element('div', {className:'transform-boundary-bottom transform-boundary bottom'}));
    this.lbndry = this.insert( new Element('div', {className:'transform-boundary-left   transform-boundary left  '}));
  },

  _installHandles: function(){
    this.moveSectionTab = this.insert(new Element('div', {className:'section-drag-tab'})).update('' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
      '<polygon points="100,50 83,33 83,46 54,46 54,17 67,17 50,0 33,17 46,17 46,46 17,46 17,33 0,50 17,67 17,54 46,54 ' +
        '46,83 33,83 50,100 67,83 54,83 54,54 83,54 83,67 "/>' +
      '</svg>');
    this.bmh            = this.insert(new lp.editor.TransformBoxHandle(this, 'bmh',
                                      'SectionTransformBoxHandle'));

    var _uiBinding = new rxUi.Binding(['SectionTransformBox', 'moveSection'])
      , _uiEvents  = _uiBinding.bindDrag(this.moveSectionTab);

    _uiEvents.ub_subscribe(this.handleDragEvent.bind(this));
  },

  handleDragEvent: function(ev) {
    var self = this;
    var dragHandlers = {
      startDrag: function(ev){
        //TODO: refactor this next line out to use rx
        jQuery(document).trigger('draggingTransformBox');
        self.startPoint = new jui.Point(Event.pointerX(ev),Event.pointerY(ev));
        jui.dnd.manager.startTracking(self, ev);
        self.setTracking(true);
      },
      drag: function(ev) {
        jui.dnd.mouseMoveListener(ev);
        self.mouseMoveListener(ev);
      },
      endDrag: function(ev) {
        jui.dnd.mouseUpListener(ev);
        self.mouseUpListener(ev);
      }
    };
    var handler = dragHandlers[ev.type];
    if (typeof handler === 'function') {
      handler(ev);
    }
  },

  elementActivated: function(e) {
    var elm = e.data;
    if (!elm.isVisibleOnPage()){ return; }
    if (elm.type !== 'lp-pom-block'){return;}
    this.setElement(elm);
  },

  elementDeactivated: function() {
    this.setElement(null);
  },

  elementMoved: function() {
    this.positionBoundingBox();
    this.positionHandles();
  },

  mouseup:function(){
    this.setTracking( false );
    // this.editor.fireEvent('elementDragStop');
  },

  mousemove:function( e ){
    this.lastPoint = {left: Event.pointerX(e), top:Event.pointerY(e)};
    this.positionGhost(this.lastPoint);
  },

  setTracking: function(b) {
    if (this.tracking === b) {
      return;
    }

    this.tracking = b;
    if ( b ) {
      this.fireEvent('startMove', this.elm);
    } else {
      this.undoRegistered = false;
      this.fireEvent('stopMove', this.elm);
    }
  },

  setElement: function (elm) {
    if (this.elm !== null) {
      this.removeElementListeners();
    }

    this.elm = elm;

    if (this.elm && this.elm.is('displayable')) {
      this.addElementListeners();
      this.positionBoundingBox();
      this.positionHandles();
      this.show();
      this.focus();
    } else {
      this.hide();
    }
  },

  addElementListeners: function(){
    this.elm.model.addListener('attributeChanged', this.elmModelListener);
    this.elm.getRootElement().model.addListener('attributeChanged', this.elmModelListener);
    this.elm.addListener('moved', this.elementMoveListener);
    this.elm.addListener('hidden', this.elementVisibilityListener);
    this.elm.addListener('shown', this.elementVisibilityListener);
  },

  removeElementListeners: function(){
    this.elm.model.removeListener('attributeChanged', this.elmModelListener);

    var rootElement = this.elm.getRootElement();
    if (rootElement) {
      rootElement.model.removeListener('attributeChanged', this.elmModelListener);
    }

    this.elm.removeListener('moved', this.elementMoveListener);
    this.elm.removeListener('hidden', this.elementVisibilityListener);
    this.elm.removeListener('shown', this.elementVisibilityListener);
  },

  elementModelChanged: function() {
    this.positionBoundingBox();
    this.positionHandles();
  },

  positionBoundingBox: function() {
    if (this.elm === null) {
      return;
    }

    this.setOffset(this.elm.getPageOffset());

    var w = this.elm.getContentWidth();
    var h = this.elm.getContentHeight();

    this.tbndry.style.width = w+'px';
    this.rbndry.style.height = h+'px';
    this.rbndry.style.left = (w-1)+'px';
    this.bbndry.style.width = (w-1)+'px';
    this.bbndry.style.top = (h-1)+'px';
    this.lbndry.style.height = (h-1)+'px';
  },

  positionHandles: function() {
    var offsetX = this.handleW / 2;
    var w = this.elm.getContentWidth();
    var h = this.elm.getContentHeight();
    var middleX = (w / 2) - offsetX;

    if (this.editor.mainPage.getRootElement().isDisplayPositionBottom()) {
      this.bmh.setOffset({left: middleX, top: -this.handleH});
      this.bmh.addClassName('transform-handle-bmh-top');
    } else {
      this.bmh.setOffset({left: middleX, top: h});
      this.bmh.removeClassName('transform-handle-bmh-top');
    }

    // this.moveSectionTab.style.top = (h/2 - 9) + 'px';
    this.moveSectionTab.style.display = (this.elm.getRootElement().childElements.length > 1) ? 'flex' : 'none';
  },

  getStartLeft: function(){
    return this.elm.view.getLeft();
  },

  getStartTop: function(){
    return this.elm.view.getTop();
  },

  getStartWidth: function(){
    return this.elm.view.getWidth();
  },

  getStartHeight: function(){
    return this.elm.view.getHeight();
  },

  getModel: function() {
    return this.elm.model;
  },

  onkeydown: function( e ) {
    if( e.keyCode === Event.KEY_DELETE || e.keyCode === Event.KEY_BACKSPACE ) {
      this.editor.removeElement();
      e.stop();
    }
  },

  focus: function() {
    this.editor.keyController.requestFocus(this, true);
  },

  blur: function() {
    //this.setOpacity(0.3);
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/section_transform_box.js
// module id = 1021
// module chunks = 0